import React, { useEffect, useState } from "react";
import { useCollection, useHomeSlides } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

// Home — Rinko Kawauchi style: just full-bleed sliding images, no text, no links.
// Slides come from an admin-managed list. If empty, we fall back to the cover
// images of projects + commercial.
const Home = () => {
  const custom = useHomeSlides(); // null (loading) | string[]
  const projects = useCollection("projects") || [];
  const commercial = useCollection("commercial") || [];

  const slides = React.useMemo(() => {
    if (Array.isArray(custom) && custom.length > 0) return custom;
    const covers = [
      ...projects.map((p) => p.cover).filter(Boolean),
      ...commercial.map((c) => c.cover).filter(Boolean),
    ];
    return Array.from(new Set(covers));
  }, [custom, projects, commercial]);

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    setIdx(0);
    const t = setInterval(() => setIdx((s) => (s + 1) % slides.length), 4500);
    return () => clearInterval(t);
  }, [slides.length]);

  if (custom === null) return null; // still loading
  if (!slides.length) return null;

  return (
    <div
      data-testid="home-slideshow"
      className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 md:px-10"
    >
      <SEO path="/" image={slides[0]} />
      <div className="relative w-full max-w-[1000px] flex items-center justify-center" style={{ height: "82vh" }}>
        {slides.map((src, i) => (
          <img
            key={i}
            src={resolveImg(src)}
            alt=""
            aria-hidden="true"
            draggable="false"
            loading={i === 0 ? "eager" : "lazy"}
            decoding="async"
            fetchpriority={i === 0 ? "high" : "low"}
            className={`absolute max-h-full max-w-full object-contain select-none pointer-events-none transition-opacity duration-[1400ms] ${
              i === idx ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Home;
